import { faGear } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { UserJsVm } from '../../shared/generated/Admin/Models/User/JavaScript/UserJsVm';

export const getMainNavAdmin: () => NavRoute = () => ({
	name: 'Admin'
    , security: sec => sec.manageUsers
    , href: 'admin/dashboard'
    , icon: faGear
    , area: 'admin'
    , expanded: globalThis.location.href.includes("/admin/")
    , children: getAdminNavChildren()
});

function getAdminNavChildren() {
    const user = getUser();
    let navRoutes: Array<NavRoute> = [];

    navRoutes.push(
        { 
            name: 'Dashboard'
            , security: sec => sec.coreFeatures
            , exact: true
            , path: 'admin/dashboard' 
            , activeNavLink: 'admin/dashboard'
            , secondaryNav: ['Admin', 'Dashboard']
        }
        , {
            name: 'Users'
            , security: security => security.manageUsers
            , href: 'admin/dashboard'
            , expanded: globalThis.location.href.includes("/admin/users/")
            , children: [
                { 
                    name: 'User List'
                    , security: sec => sec.manageUsers
                    , exact: true
                    , path: 'admin/users/list' 
                    , activeNavLink: 'admin/users'
                    , secondaryNav: ['Admin', 'Users', 'User List']
                }
                , {
                    name: 'Login History'
                    , security: sec => sec.manageUsers
                    , exact: true
                    , path: 'admin/users/login-history'
                    , activeNavLink: 'admin/users/login-history'
                    , secondaryNav: [ 'Admin', 'Users', 'Login History' ]
                }
            ]
        }
    );

    if (user?.email?.includes("@paulconsulting.com")) {
        navRoutes.push(
            {
                name: 'System Settings'
                , security: sec => sec.adminFeatures
                , exact: true
                , path: 'admin/system-settings'
                , activeNavLink: 'admin/system-settings'
                , secondaryNav: [ 'Admin', 'System Settings' ]
            }
        );
    }

    navRoutes.push(
        {
			name: 'Global Audit History'
			, security: sec => sec.adminFeatures
			, exact: true
			, path: 'admin/global-audit-list'
            , activeNavLink: 'admin/global-audit-list'
            , secondaryNav: [ 'Admin', 'Global Audit History' ]
		}
    );

    /* navRoutes.push(
        { 
			name: 'Quartz'
			, security: sec => sec.viewQuartzJobs
            , href: 'admin/jobs/history'
			, path: 'quartz'
            , expanded: globalThis.location.href.includes("/admin/jobs/")
			, children: getQuartzChildren()
		}
    ); */

    navRoutes.push(
        {
            name: 'Footer Admin'
            , security: sec => sec.adminFeatures 
            , href: 'admin/footer-admin/release-notes/list'
            , expanded: globalThis.location.href.includes("/admin/footer-admin/")
            , children: getFooterAdminChildren()
        }
    );

    return navRoutes;
}

// #region Quartz
function getQuartzChildren() {
    return [
        {
			name: 'Quartz History'
            , security: (sec: { viewQuartzJobs: boolean; }) => sec.viewQuartzJobs === true
            , exact: true
            , path: 'admin/jobs/history'
            , activeNavLink: 'admin/jobs/history'
            , secondaryNav: ['Admin', 'Quartz', 'Quartz History']
		}
		, {
			name: 'Quartz'
            , security: (sec: { viewQuartzJobs: boolean; }) => sec.viewQuartzJobs === true
            , exact: true
            , path: 'quartz'
            , openNewTab: true 
		}
	]
}
// #endregion

// #region Footer Admin
function getFooterAdminChildren() {
    let id: string = "";
    let url = globalThis.location.href;

    if (url.includes('footer-admin/release-notes/edit')) { id = url.substring(url.lastIndexOf('/') + 1); }

    if (id === "") {
        return [
            { 
                name: 'Release Notes'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/release-notes/list' 
                , activeNavLink: 'admin/footer-admin/release-notes'
                , secondaryNav: ['Admin', 'Footer Admin', 'Release Notes']
            }
            , { 
                name: 'EULA'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/eula' 
                , activeNavLink: 'admin/footer-admin/eula'
                , secondaryNav: ['Admin', 'Footer Admin', 'EULA']
            }
            , { 
                name: 'Privacy Policy'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/privacy-policy' 
                , activeNavLink: 'admin/footer-admin/privacy-policy'
                , secondaryNav: ['Admin', 'Footer Admin', 'Privacy Policy']
            }
            , { 
                name: 'Terms and Conditions'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/terms-and-conditions' 
                , activeNavLink: 'admin/footer-admin/terms-and-conditions'
                , secondaryNav: ['Admin', 'Footer Admin', 'Terms and Conditions']
            }
        ]
    }

    if (id != null) {
        return [
            { 
                name: 'Release Notes'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/release-notes/list' 
                , activeNavLink: 'admin/footer-admin/release-notes'
                , secondaryNav: ['Admin', 'Footer Admin', 'Release Notes']
            }
            , { 
                name: 'EULA'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/eula' 
                , activeNavLink: 'admin/footer-admin/eula'
                , secondaryNav: ['Admin', 'Footer Admin', 'EULA']
            }
            , { 
                name: 'Privacy Policy'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/privacy-policy' 
                , activeNavLink: 'admin/footer-admin/privacy-policy'
                , secondaryNav: ['Admin', 'Footer Admin', 'Privacy Policy']
            }
            , { 
                name: 'Terms and Conditions'
                , security: (sec: { adminFeatures: boolean; }) => sec.adminFeatures === true
                , exact: true
                , path: 'admin/footer-admin/terms-and-conditions' 
                , activeNavLink: 'admin/footer-admin/terms-and-conditions'
                , secondaryNav: ['Admin', 'Footer Admin', 'Terms and Conditions']
            }
        ]
    }
}
// #endregion

function getUser(): UserJsVm {
	const userJson: string | null = localStorage.getItem('user');
	if (userJson !== null) { return JSON.parse(userJson); }
	return null!;
}